import { useCallback, useState } from 'react';
import { Button, Grid, IconButton, TextField, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import MuiAccordion from '@mui/material/Accordion';
import Select from 'react-select';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import { Box, Stack } from '@mui/system';
import customStyles from 'app/shared-components/SelectCustomStyle';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { checkNumber, emailValidation } from '../../../utilities/FormValidation';
import nationalityListData from '../countries-nationality-list'
import { useEffect } from 'react';
import oAuthServiceConfig from 'src/app/auth/services/oAuthService/oAuthServiceConfig';
import OAuthService from 'src/app/auth/services/oAuthService';
import CustomDatePicker from '../../../utilities/CustomDatePicker';



/*--------------------------------Accordion-------------------------------------*/

const Accordion = styled((props) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
    border: `1px solid ${theme.palette.divider}`,
    '&:not(:last-child)': {
        borderBottom: 0,
    },
    '&:before': {
        display: 'none',
    },
}));

const AccordionSummary = styled((props) => (
    <MuiAccordionSummary
        expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
        {...props}
    />
))(({ theme }) => ({
    backgroundColor:
        theme.palette.mode === 'dark'
            ? 'rgba(255, 255, 255, .05)'
            : 'rgba(0, 0, 0, .03)',
    flexDirection: 'row-reverse',
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
        transform: 'rotate(90deg)',
    },
    '& .MuiAccordionSummary-content': {
        marginLeft: theme.spacing(1),
    },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(2),
    borderTop: '1px solid rgba(0, 0, 0, .125)',
}));

/*------------------------------------------------------------------------------------*/




const Organization = ({ handleDocumentChange,validError, setValidError,  checkSubmit, document, setDocument ,employeeRecord, passportInfo, setPassportInfo, familyInfo, emergencyContact,legelNominee, bankInfo,
     handleEmployeeRecordChange, handlePassPortInfoChange, handleFamilyInfoChange, handleEmergencyContactChange, handleLegalNomineeChange,
    handleBankInfoChange, setEmployeeRecord, setFamilyInfo}) => {
    const [expanded, setExpanded] = useState('panel1');
    const [nationalityOptions, setNationalityOptions] = useState();

    const handleChangePanel = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false);
    };

    // const document = [
    //     { fileName: "File 1", type: "PDF", size: "150kb", uploadedDate: "25-05-2023" },
    //     { fileName: "File 2", type: "JPEG", size: "650kb", uploadedDate: "25-05-2023" },
    //     { fileName: "File 3", type: "PDF", size: "15kb", uploadedDate: "25-05-2023" },
    //     { fileName: "File 4", type: "WORD", size: "60kb", uploadedDate: "25-05-2023" },
    //     { fileName: "File 5", type: "PDF", size: "750kb", uploadedDate: "25-05-2023" },
    // ]

    const departmentOptions = [
        {value:1, label:"HR"},
        {value:2, label:"Deployment"},
        {value:3, label:"Testing"},
        {value:4, label:"BDE"},
    ]
    const reportingManagerOptions = [
        {value:1, label:"Reporting Manager 1"},
        {value:2, label:"Reporting Manager 2"},
        {value:3, label:"Reporting Manager 3"},
        {value:4, label:"Reporting Manager 4"},
    ]
    const roleOptions = [
        {value:1, label:"Management"},
        {value:2, label:"Support"},
        {value:3, label:"Developer"},
    ]
    const contractTypeOptions = [
        {value:1, label:"Permanent"},
        {value:2, label:"Contract"},
        {value:3, label:"Freelancer"},
    ]
    const civilStatusOptions=[
        {value:1, label:"Single"},
        {value:2, label:"Married"},
    ]

    const handleDepartmentChange = (data) => {
        setEmployeeRecord({ ...employeeRecord, department : data.label });
    };
    const handleReportingManagerChange = (data,action) => {
        setEmployeeRecord({ ...employeeRecord, reportingManager:action.action === "clear" ? "": data.label });
    };
    const handleRoleChange = (data,action) => {
        setEmployeeRecord({ ...employeeRecord, role: action.action === "clear" ? "": data.label });
    };
    const handleContractTypeChange = (data,action) => {
        setEmployeeRecord({ ...employeeRecord, contractType: action.action === "clear" ? "": data.label });
    };
    const handleCivilStatusChange = (data,action) =>{
        setFamilyInfo({...familyInfo, civilStatus: action.action === "clear" ? "": data.label})
    }
    const changeNationality = async (data,action) => {
        setPassportInfo({ ...passportInfo, nationality: action.action === "clear" ? "": data.label });
    };
    const changeSpouseNationality = async (data,action) => {
        setFamilyInfo({ ...familyInfo, spouseNationality: action.action === "clear" ? "": data.label });
    };

    const removeFile = (index)=>{
        const result = document.filter((item,i)=> i !== index)
        setDocument(result);
    }

    useEffect(() => {
        const country = async () => {
            const countryURL = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.country}`;
            const countriesList = await OAuthService.getList(countryURL + '?size=100');
            let countries = countriesList?.data?._embedded.countries

            let result = nationalityListData.filter((countriesData) => countries.find((countryList) => countryList.isoCode === countriesData.isoCode));
            result = result.map((value) => {
                return { label: value?.nationality, value: value?.isoCode }
            });
            setNationalityOptions(result);
        }
        country();
    }, []);
    

    return (
        <div>
            <Accordion expanded={expanded === 'panel1'} onChange={handleChangePanel('panel1')}>
                <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
                    <Typography>Employee Master Record</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Grid container spacing={2}>
                        <Grid item xs={3}>
                            <Stack>
                                <label>Joining Date</label>
                                <CustomDatePicker 
                                    format={'dd-MM-yyyy'}
                                    name={'joiningDate'}
                                    value={employeeRecord.joiningDate}
                                    maxDate={new Date()}
                                    handleChange={(e) => handleEmployeeRecordChange(e, "joiningDate")}
                                />
                                {/* <Typography mt={0.5} className="text-[#f44336] text-sm ml-14">{(checksubmit && !validUntil) ? "" : validError.validUntil}</Typography> */}
                            </Stack>
                        </Grid>
                        <Grid item xs={3}>
                            <Stack>
                                <label>Seniority Date</label>
                                <CustomDatePicker 
                                    format={'dd-MM-yyyy'}
                                    name={'seniorityDate'}
                                    value={employeeRecord.seniorityDate}
                                    handleChange={(e) => handleEmployeeRecordChange(e, "seniorityDate")}
                                    />
                                {/* <Typography mt={0.5} className="text-[#f44336] text-sm ml-14">{(checksubmit && !validUntil) ? "" : validError.validUntil}</Typography> */}
                            </Stack>
                        </Grid>
                        <Grid item xs={3}>
                            <Stack>
                                <label>Employment</label>
                                <TextField
                                    className="mb-16"
                                    type="text"
                                    name="employment"
                                    value={employeeRecord.employment}
                                    onChange={(e) => handleEmployeeRecordChange(e)}
                                    variant="outlined"
                                />
                            </Stack>
                        </Grid>
                        <Grid item xs={3}>
                            <Stack>
                                <label>*Designation</label>
                                <TextField
                                    className="mb-16"
                                    type="text"
                                    name="designation"
                                    value={employeeRecord.designation}
                                    onChange={(e) => handleEmployeeRecordChange(e)}
                                    variant="outlined"
                                />
                            </Stack>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={3}>
                            <Stack>
                                <label>*Select Department</label>
                                <Select
                                    className="mb-16"
                                    name="department"
                                    value={(employeeRecord.department && departmentOptions) && departmentOptions.filter(obj => employeeRecord.department === obj.label)}
                                    onChange={handleDepartmentChange}
                                    options={departmentOptions}
                                    styles={customStyles()}
                                />
                                {/* <Typography mt={0.5} className="text-[#f44336] text-sm ml-14">{(checksubmit && !department) ? "" : validError.department}</Typography> */}
                            </Stack>
                        </Grid>
                        <Grid item xs={3}>
                            <Stack>
                                <label>Select Reporting Manager</label>
                                <Select
                                    className="mb-16"
                                    name="reportingManager"
                                    value={(employeeRecord.reportingManager && reportingManagerOptions) && reportingManagerOptions.filter(obj => employeeRecord.reportingManager === obj.label)}
                                    onChange={handleReportingManagerChange}
                                    options={reportingManagerOptions}
                                    styles={customStyles()}
                                    isClearable
                                />
                                {/* <Typography mt={0.5} className="text-[#f44336] text-sm ml-14">{(checksubmit && !reportingManager) ? "" : validError.reportingManager}</Typography> */}
                            </Stack>
                        </Grid>
                        <Grid item xs={3}>
                            <Stack>
                                <label>Select Role</label>
                                <Select
                                    className="mb-16"
                                    name="role"
                                    value={(employeeRecord.role && roleOptions) && roleOptions.filter(obj => employeeRecord.role === obj.label)}
                                    onChange={handleRoleChange}
                                    options={roleOptions}
                                    styles={customStyles()}
                                    isClearable
                                />
                                {/* <Typography mt={0.5} className="text-[#f44336] text-sm ml-14">{(checksubmit && !role) ? "" : validError.role}</Typography> */}
                            </Stack>
                        </Grid>
                        <Grid item xs={3}>
                            <Stack>
                                <label>Select Contract Type</label>
                                <Select
                                    className="mb-16"
                                    name="contractType"
                                    value={(employeeRecord.contractType && contractTypeOptions) && contractTypeOptions.filter(obj => employeeRecord.contractType === obj.label)}
                                    onChange={handleContractTypeChange}
                                    options={contractTypeOptions}
                                    styles={customStyles()}
                                    isClearable
                                />
                                {/* <Typography mt={0.5} className="text-[#f44336] text-sm ml-14">{(checksubmit && !contractType) ? "" : validError.contractType}</Typography> */}
                            </Stack>
                        </Grid>
                    </Grid>
                </AccordionDetails>
            </Accordion>
            <Accordion expanded={expanded === 'panel2'} onChange={handleChangePanel('panel2')}>
                <AccordionSummary aria-controls="panel2d-content" id="panel2d-header">
                    <Typography>Passport Information</Typography>
                </AccordionSummary>
                <AccordionDetails>

                    <Grid container spacing={2}>
                        <Grid item xs={3}>
                            <Stack>
                                <label>Name as per Passport</label>
                                <TextField
                                    className="mb-16"
                                    type="text"
                                    name="namePassport"
                                    value={passportInfo.namePassport}
                                    onChange={(e) => handlePassPortInfoChange(e)}
                                    variant="outlined"
                                />
                            </Stack>
                        </Grid>
                        <Grid item xs={3}>
                            <Stack>
                                <label>Passport Number</label>
                                <TextField
                                    className="mb-16"
                                    type="text"
                                    name="passportNumber"
                                    value={passportInfo.passportNumber}
                                    onChange={(e) => handlePassPortInfoChange(e)}
                                    variant="outlined"
                                />
                            </Stack>
                        </Grid>
                        <Grid item xs={3}>
                            <Stack className="mb-16">
                                    <label>Nationality</label>
                                    <Select name="country"
                                        placeholder="Select Nationality"
                                        value={(nationalityOptions && passportInfo.nationality) && nationalityOptions.filter(obj => passportInfo.nationality.includes(obj.label))}
                                        onChange={changeNationality}
                                        className="select"
                                        classNamePrefix="select"
                                        options={nationalityOptions}
                                        // styles={customStyles(((checksubmit && !passportInfo.nationality) || validError.passportInfo.nationality) ? "none" : "none")}
                                        styles={customStyles()}
                                        isClearable
                                    />
                                    {/* <Typography sx={{ color: 'red', fontSize: "1.2rem", padding: "5px 0px 0px 10px" }}>{(checksubmit && !passportInfo.nationality) ? "This field is required" : validError.passportInfo.nationality}</Typography> */}
                                </Stack>
                        </Grid>
                        <Grid item xs={3}>
                            <Stack>
                                <label>Place of Issue</label>
                                <TextField
                                    className="mb-16"
                                    type="text"
                                    name="placeOfIssue"
                                    value={passportInfo.placeOfIssue}
                                    onChange={(e) => handlePassPortInfoChange(e)}
                                    variant="outlined"
                                />
                            </Stack>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={3}>
                            <Stack>
                                <label>Issue Date</label>
                                <CustomDatePicker 
                                    format={'dd-MM-yyyy'}
                                    name={'issueDate'}
                                    value={passportInfo.issueDate}
                                    maxDate={new Date()}
                                    handleChange={(e) => handleEmployeeRecordChange(e, "issueDate")}
                                />
                                {/* <Typography mt={0.5} className="text-[#f44336] text-sm ml-14">{(checksubmit && !issueDate) ? "" : validError.issueDate}</Typography> */}
                            </Stack>
                        </Grid>
                        <Grid item xs={3}>
                            <Stack>
                                <label>Expiry Date</label>
                                <CustomDatePicker 
                                    format={'dd-MM-yyyy'}
                                    name={'expiryDate'}
                                    value={passportInfo.expiryDate}
                                    minDate={passportInfo.issueDate}
                                    handleChange={(e) => handleEmployeeRecordChange(e, "expiryDate")}
                                />
                                {/* <Typography mt={0.5} className="text-[#f44336] text-sm ml-14">{(checksubmit && !expiryDate) ? "" : validError.expiryDate}</Typography> */}
                            </Stack>
                        </Grid>
                        <Grid item xs={3}>
                            <Stack>
                                <label>Issued By</label>
                                <TextField
                                    className="mb-16"
                                    type="text"
                                    name="issuedBy"
                                    value={passportInfo.issuedBy}
                                    onChange={(e) => handlePassPortInfoChange(e)}
                                    variant="outlined"
                                />
                            </Stack>
                        </Grid>
                        <Grid item xs={3}>
                            <Stack>
                                <label>Issue In</label>
                                <TextField
                                    className="mb-16"
                                    type="text"
                                    name="issueIn"
                                    value={passportInfo.issueIn}
                                    onChange={(e) => handlePassPortInfoChange(e)}
                                    variant="outlined"
                                />
                            </Stack>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <Stack className='w-full mb-16'>
                                <label>Document Upload</label>
                                <Box className='flex justify-center items-center'
                                    sx={{
                                        height: 180,
                                        border: '2px dotted grey',
                                    }}
                                >
                                    <CloudUploadOutlinedIcon fontSize={'large'} /><Typography className='ml-12' >Upload Document</Typography>
                                    <Button
                                        variant="contained"
                                        component="label"
                                        color="warning"
                                        className='ml-12'
                                    >
                                        <input hidden multiple type="file" onChange={(e) => handleDocumentChange(e)} />
                                        <Typography color="black">Browse</Typography>
                                    </Button>
                                </Box>
                            </Stack>
                        </Grid>
                        <Grid item xs={6} >
                            <Stack className='w-full mb-16'>
                                <label>Uploaded Documents</label>
                                <TableContainer component={Paper} sx={{ border: "1px solid gray", borderRadius: 0, height: "300px" }}>
                                    <Table aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>File Name</TableCell>
                                                <TableCell>Type</TableCell>
                                                <TableCell>Size</TableCell>
                                                <TableCell>Uploaded Date</TableCell>
                                                <TableCell></TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {document.map((row,index) => (
                                                <TableRow
                                                    key={row.name}

                                                >
                                                    <TableCell component="th" scope="row">
                                                        {row.name}
                                                    </TableCell>
                                                    <TableCell>{row.type}</TableCell>
                                                    <TableCell>{row.size}</TableCell>
                                                    <TableCell>{row.uploadedDate}</TableCell>
                                                    <TableCell><IconButton onClick={()=>removeFile(index)}><DeleteForeverIcon color="warning" /></IconButton></TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Stack>

                        </Grid>
                    </Grid>

                </AccordionDetails>
            </Accordion>
            <Accordion expanded={expanded === 'panel3'} onChange={handleChangePanel('panel3')}>
                <AccordionSummary aria-controls="panel3d-content" id="panel3d-header">
                    <Typography>Family Information</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Grid container spacing={2}>
                        <Grid item xs={4}>
                            <Stack>
                                <label>Father Name</label>
                                <TextField
                                    className="mb-16"
                                    type="text"
                                    name="fatherName"
                                    value={familyInfo.fatherName}
                                    onChange={(e) => handleFamilyInfoChange(e)}
                                    variant="outlined"
                                />
                            </Stack>
                        </Grid>
                        <Grid item xs={4}>
                            <Stack>
                                <label>Email</label>
                                <TextField
                                    className="mb-16"
                                    type="text"
                                    name="fatherEmail"
                                    value={familyInfo.fatherEmail}
                                    error={(checkSubmit && !familyInfo.fatherEmail) || validError.fatherEmail ? true : false}
                                    helperText={(checkSubmit && !familyInfo.fatherEmail) ? "" : validError.fatherEmail}
                                    onChange={(e) => {handleFamilyInfoChange(e); setValidError({ ...validError, fatherEmail: emailValidation(e.target.value)})}}
                                    variant="outlined"
                                />
                            </Stack>
                        </Grid>
                        <Grid item xs={4}>
                            <Stack>
                                <label>Contact Number</label>
                                <TextField
                                    className="mb-16"
                                    type="text"
                                    name="fatherContact"
                                    value={familyInfo.fatherContact}
                                    error={(checkSubmit && !familyInfo.fatherContact) || validError.fatherContact ? true : false}
                                    helperText={(checkSubmit && !familyInfo.fatherContact) ? "" : validError.fatherContact}
                                    onChange={(e) => {handleFamilyInfoChange(e); setValidError({ ...validError, fatherContact: checkNumber(e.target.value)})}}
                                    variant="outlined"
                                />
                            </Stack>
                        </Grid>
                    </Grid>
                    <Stack>
                        <label>Address</label>
                        <TextField
                            className="mb-16"
                            type="text"
                            name="address1"
                            value={familyInfo.fatherAddress.address1}
                            onChange={(e) => handleFamilyInfoChange(e,"fatherAddress")}
                            variant="outlined"
                        />
                    </Stack>
                    <Grid container spacing={2}>
                        <Grid item xs={4}>
                            <Stack>
                                <label>Mother Name</label>
                                <TextField
                                    className="mb-16"
                                    type="text"
                                    name="motherName"
                                    value={familyInfo.motherName}
                                    onChange={(e) => handleFamilyInfoChange(e)}
                                    variant="outlined"
                                />
                            </Stack>
                        </Grid>
                        <Grid item xs={4}>
                            <Stack>
                                <label>Email</label>
                                <TextField
                                    className="mb-16"
                                    type="text"
                                    name="motherEmail"
                                    value={familyInfo.motherEmail}
                                    error={(checkSubmit && !familyInfo.motherEmail) || validError.motherEmail ? true : false}
                                    helperText={(checkSubmit && !familyInfo.motherEmail) ? "" : validError.motherEmail}
                                    onChange={(e) => {handleFamilyInfoChange(e); setValidError({ ...validError, motherEmail: emailValidation(e.target.value)})}}
                                    variant="outlined"
                                />
                            </Stack>
                        </Grid>
                        <Grid item xs={4}>
                            <Stack>
                                <label>Contact Number</label>
                                <TextField
                                    className="mb-16"
                                    type="text"
                                    name="motherContact"
                                    value={familyInfo.motherContact}
                                    error={(checkSubmit && !familyInfo.motherContact) || validError.motherContact ? true : false}
                                    helperText={(checkSubmit && !familyInfo.motherContact) ? "" : validError.motherContact }
                                    onChange={(e) =>{ handleFamilyInfoChange(e);setValidError({ ...validError, motherContact: checkNumber(e.target.value)})}}
                                    variant="outlined"
                                />
                            </Stack>
                        </Grid>
                    </Grid>
                    <Stack>
                        <label>Address</label>
                        <TextField
                            className="mb-16"
                            type="text"
                            name="address1"
                            value={familyInfo.motherAddress.address1}
                            onChange={(e) => handleFamilyInfoChange(e,"motherAddress")}
                            variant="outlined"
                        />
                    </Stack>

                    <Grid container spacing={2}>
                        <Grid item xs={4}>
                            <Stack>
                                <label>Select Civil Status</label>
                                <Select
                                    className="mb-16"
                                    name="civilStatus"
                                    value={(familyInfo.civilStatus && civilStatusOptions) && civilStatusOptions.filter(obj => familyInfo.civilStatus === obj.label)}
                                    onChange={handleCivilStatusChange}
                                    options={civilStatusOptions}
                                    styles={customStyles()}
                                    isClearable
                                />
                                {/* <Typography mt={0.5} className="text-[#f44336] text-sm ml-14">{(checksubmit && !civilStatus) ? "" : validError.civilStatus}</Typography> */}
                            </Stack>
                        </Grid>
                        {familyInfo.civilStatus === "Married" && <Grid item xs={4}>
                            <Stack>
                                <label>Spouse Name</label>
                                <TextField
                                    className="mb-16"
                                    type="text"
                                    name="spouseName"
                                    value={familyInfo.spouseName}
                                    onChange={(e) => handleFamilyInfoChange(e)}
                                    variant="outlined"
                                />
                            </Stack>
                        </Grid>
                        
                        }
                        
                        {familyInfo.civilStatus === "Married" && <Grid item xs={4}>
                            <Stack className="mb-16">
                                    <label>Nationality</label>
                                    <Select name="spouseNationality"
                                        placeholder="Select Nationality"
                                        value={(nationalityOptions && familyInfo.spouseNationality) && nationalityOptions.filter(obj => familyInfo.spouseNationality.includes(obj.label))}
                                        onChange={changeSpouseNationality}
                                        className="select"
                                        classNamePrefix="select"
                                        options={nationalityOptions}
                                        // styles={customStyles(((checksubmit && !familyInfo.spouseNationality) || validError.familyInfo.spouseNationality) ? "none" : "none")}
                                        styles={customStyles()}
                                        isClearable
                                    />
                                    {/* <Typography sx={{ color: 'red', fontSize: "1.2rem", padding: "5px 0px 0px 10px" }}>{(checksubmit && !familyInfo.spouseNationality) ? "This field is required" : validError.familyInfo.spouseNationality}</Typography> */}
                                </Stack>
                        </Grid>}
                    </Grid>
                    {familyInfo.civilStatus === "Married" && <Grid container spacing={2}>
                        <Grid item xs={4}>
                            <Stack>
                                <label>Number of Children</label>
                                <TextField
                                    className="mb-16"
                                    type="text"
                                    name="noOfChildren"
                                    value={familyInfo.noOfChildren}
                                    onChange={(e) => handleFamilyInfoChange(e)}
                                    variant="outlined"
                                />
                            </Stack>
                        </Grid>
                        <Grid item xs={4}>
                            <Stack>
                                <label>Spouse Contact Number</label>
                                <TextField
                                    className="mb-16"
                                    type="text"
                                    name="spouseContact"
                                    value={familyInfo.spouseContact}
                                    error={(checkSubmit && !familyInfo.spouseContact) || validError.spouseContact ? true : false}
                                    helperText={(checkSubmit && !familyInfo.spouseContact) ? "" : validError.spouseContact }
                                    onChange={(e) =>{ handleFamilyInfoChange(e); setValidError({ ...validError, spouseContact: checkNumber(e.target.value)})}}
                                    variant="outlined"
                                />
                            </Stack>
                        </Grid>
                        <Grid item xs={4}>
                            <Stack>
                                <label>Spouse Email</label>
                                <TextField
                                    className="mb-16"
                                    type="text"
                                    name="spouseEmail"
                                    value={familyInfo.spouseEmail}
                                    error={(checkSubmit && !familyInfo.spouseEmail) || validError.spouseEmail ? true : false}
                                    helperText={(checkSubmit && !familyInfo.spouseEmail) ? "" : validError.spouseEmail }
                                    onChange={(e) => {handleFamilyInfoChange(e); setValidError({ ...validError, spouseEmail: emailValidation(e.target.value)})}}
                                    variant="outlined"
                                />
                            </Stack>
                        </Grid>
                    </Grid>}
                    {familyInfo.civilStatus === "Married" && <Stack>
                        <label>Spouse Home Address</label>
                        <TextField
                            className="mb-16"
                            type="text"
                            name="address1"
                            value={familyInfo.spouseHomeAddress.address1}
                            onChange={(e) => handleFamilyInfoChange(e,"spouseHomeAddress")}
                            variant="outlined"
                        />
                    </Stack>}
                </AccordionDetails>
            </Accordion>
            <Accordion expanded={expanded === 'panel4'} onChange={handleChangePanel('panel4')}>
                <AccordionSummary aria-controls="panel4d-content" id="panel4d-header">
                    <Typography>Emergency Contact</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Grid container spacing={2}>
                        <Grid item xs={4}>
                            <Stack>
                                <label>Name</label>
                                <TextField
                                    className="mb-16"
                                    type="text"
                                    name="name"
                                    value={emergencyContact.name}
                                    onChange={(e) => handleEmergencyContactChange(e)}
                                    variant="outlined"
                                />
                            </Stack>
                        </Grid>
                        <Grid item xs={4}>
                            <Stack>
                                <label>Relation</label>
                                <TextField
                                    className="mb-16"
                                    type="text"
                                    name="relation"
                                    value={emergencyContact.relation}
                                    onChange={(e) => handleEmergencyContactChange(e)}
                                    variant="outlined"
                                />
                            </Stack>
                        </Grid>
                        <Grid item xs={4}>
                            <Stack>
                                <label>Mobile Number</label>
                                <TextField
                                    className="mb-16"
                                    type="text"
                                    name="mobileNumber"
                                    value={emergencyContact.mobileNumber}
                                    error={(checkSubmit && !emergencyContact.mobileNumber) || validError.emergencyContactMobileNumber ? true : false}
                                    helperText={(checkSubmit && !emergencyContact.mobileNumber) ? "" : validError.emergencyContactMobileNumber}
                                    onChange={(e) => {handleEmergencyContactChange(e); setValidError({ ...validError, emergencyContactMobileNumber: checkNumber(e.target.value)})}}
                                    variant="outlined"
                                />
                            </Stack>
                        </Grid>

                    </Grid>
                    <Stack>
                        <label>Address</label>
                        <TextField
                            className="mb-16"
                            type="text"
                            name="address1"
                            value={emergencyContact.address.address1}
                            onChange={(e) => handleEmergencyContactChange(e,"emergencyContact")}
                            variant="outlined"
                        />
                    </Stack>
                    <Grid container spacing={2}>
                        <Grid item xs={4}>
                            <Stack>
                                <label>Telephone</label>
                                <TextField
                                    className="mb-16"
                                    type="text"
                                    name="telephone"
                                    value={emergencyContact.telephone}
                                    error={(checkSubmit && !emergencyContact.telephone) || validError.emergencyContactTelephone ? true : false}
                                    helperText={(checkSubmit && !emergencyContact.telephone) ? "" : validError.emergencyContactTelephone}
                                    onChange={(e) => {handleEmergencyContactChange(e); setValidError({ ...validError, emergencyContactTelephone: checkNumber(e.target.value)})}}
                                    variant="outlined"
                                />
                            </Stack>
                        </Grid>
                        <Grid item xs={4}>
                            <Stack>
                                <label>Email</label>
                                <TextField
                                    className="mb-16"
                                    type="text"
                                    name="email"
                                    value={emergencyContact.email}
                                    error={(checkSubmit && !emergencyContact.email) || validError.emergencyContactEmail ? true : false}
                                    helperText={(checkSubmit && !emergencyContact.email) ? "" : validError.emergencyContactEmail}
                                    onChange={(e) =>{ handleEmergencyContactChange(e); setValidError({ ...validError, emergencyContactEmail: emailValidation(e.target.value)})}}
                                    variant="outlined"
                                />
                            </Stack>
                        </Grid>
                    </Grid>
                </AccordionDetails>
            </Accordion>
            <Accordion expanded={expanded === 'panel5'} onChange={handleChangePanel('panel5')}>
                <AccordionSummary aria-controls="panel5d-content" id="panel5d-header">
                    <Typography>Legal Nominee (In case of eventualisties)</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Grid container spacing={2}>
                        <Grid item xs={4}>
                            <Stack>
                                <label>Name</label>
                                <TextField
                                    className="mb-16"
                                    type="text"
                                    name="name"
                                    value={legelNominee.name}
                                    onChange={(e) => handleLegalNomineeChange(e)}
                                    variant="outlined"
                                />
                            </Stack>
                        </Grid>
                        <Grid item xs={4}>
                            <Stack>
                                <label>Relation</label>
                                <TextField
                                    className="mb-16"
                                    type="text"
                                    name="relation"
                                    value={legelNominee.relation}
                                    onChange={(e) => handleLegalNomineeChange(e)}
                                    variant="outlined"
                                />
                            </Stack>
                        </Grid>
                        <Grid item xs={4}>
                            <Stack>
                                <label>Mobile Number</label>
                                <TextField
                                    className="mb-16"
                                    type="text"
                                    name="mobileNumber"
                                    value={legelNominee.mobileNumber}
                                    error={(checkSubmit && !legelNominee.mobileNumber) || validError.legelNomineeMobileNumber ? true : false}
                                    helperText={(checkSubmit && !legelNominee.mobileNumber) ? "" : validError.legelNomineeMobileNumber}
                                    onChange={(e) => {handleLegalNomineeChange(e); setValidError({ ...validError, legelNomineeMobileNumber: checkNumber(e.target.value)})}}
                                    variant="outlined"
                                />
                            </Stack>
                        </Grid>

                    </Grid>
                    <Stack>
                        <label>Address</label>
                        <TextField
                            className="mb-16"
                            type="text"
                            name="address1"
                            value={legelNominee.address.address1}
                            onChange={(e) => handleLegalNomineeChange(e,"legelNominee")}
                            variant="outlined"
                        />
                    </Stack>
                    <Grid container spacing={2}>
                        <Grid item xs={4}>
                            <Stack>
                                <label>Telephone</label>
                                <TextField
                                    className="mb-16"
                                    type="text"
                                    name="telephone"
                                    value={legelNominee.telephone}
                                    error={(checkSubmit && !legelNominee.telephone) || validError.legelNomineeTelephone ? true : false}
                                    helperText={(checkSubmit && !legelNominee.telephone) ? "" : validError.legelNomineeTelephone}
                                    onChange={(e) => {handleLegalNomineeChange(e);setValidError({ ...validError, legelNomineeTelephone: checkNumber(e.target.value)})}}
                                    variant="outlined"
                                />
                            </Stack>
                        </Grid>
                        <Grid item xs={4}>
                            <Stack>
                                <label>Email</label>
                                <TextField
                                    className="mb-16"
                                    type="text"
                                    name="email"
                                    value={legelNominee.email}
                                    error={(checkSubmit && !legelNominee.email) || validError.legelNomineeEmail ? true : false}
                                    helperText={(checkSubmit && !legelNominee.email) ? "" : validError.legelNomineeEmail}
                                    onChange={(e) => {handleLegalNomineeChange(e);setValidError({ ...validError, legelNomineeEmail: emailValidation(e.target.value)})}}
                                    variant="outlined"
                                />
                            </Stack>
                        </Grid>
                    </Grid>
                </AccordionDetails>
            </Accordion>
            <Accordion expanded={expanded === 'panel6'} onChange={handleChangePanel('panel6')}>
                <AccordionSummary aria-controls="panel6d-content" id="panel6d-header">
                    <Typography>Financial Integration</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Grid container spacing={2}>
                        <Grid item xs={4}>
                            <Stack>
                                <label>Bank Name</label>
                                <TextField
                                    className="mb-16"
                                    type="text"
                                    name="bankName"
                                    value={bankInfo.bankName}
                                    onChange={(e) => handleBankInfoChange(e)}
                                    variant="outlined"
                                />
                            </Stack>
                        </Grid>
                        <Grid item xs={4}>
                            <Stack>
                                <label>Account Name</label>
                                <TextField
                                    className="mb-16"
                                    type="text"
                                    name="accountName"
                                    value={bankInfo.accountName}
                                    onChange={(e) => handleBankInfoChange(e)}
                                    variant="outlined"
                                />
                            </Stack>
                        </Grid>
                        <Grid item xs={4}>
                            <Stack>
                                <label>Account Number</label>
                                <TextField
                                    className="mb-16"
                                    type="text"
                                    name="accountNumber"
                                    value={bankInfo.accountNumber}
                                    error={(checkSubmit && !bankInfo.accountName) || validError.accountNumber ? true : false}
                                    helperText={(checkSubmit && !bankInfo.accountName) ? "" : validError.accountNumber}
                                    onChange={(e) => {handleBankInfoChange(e);setValidError({ ...validError, accountNumber: checkNumber(e.target.value)})}}
                                    variant="outlined"
                                />
                            </Stack>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={4}>
                            <Stack>
                                <label>Location</label>
                                <TextField
                                    className="mb-16"
                                    type="text"
                                    name="location"
                                    value={bankInfo.location}
                                    onChange={(e) => handleBankInfoChange(e)}
                                    variant="outlined"
                                />
                            </Stack>
                        </Grid>
                        <Grid item xs={4}>
                            <Stack>
                                <label>IBAN</label>
                                <TextField
                                    className="mb-16"
                                    type="text"
                                    name="iban"
                                    value={bankInfo.iban}
                                    onChange={(e) => handleBankInfoChange(e)}
                                    variant="outlined"
                                />
                            </Stack>
                        </Grid>
                        <Grid item xs={4}>
                            <Stack>
                                <label>Other Info</label>
                                <TextField
                                    className="mb-16"
                                    type="text"
                                    name="otherInfo"
                                    value={bankInfo.otherInfo}
                                    onChange={(e) => handleBankInfoChange(e)}
                                    variant="outlined"
                                />
                            </Stack>
                        </Grid>
                    </Grid>
                </AccordionDetails>
            </Accordion>
        </div>
    )
}

export default Organization